import {
  getMediaTypeLabel,
  RESOURCE_SEARCH_TYPE,
} from "@modules/resource-search/resource-search-helper.ts";
import { ResourceCardProps } from "@/common/card-types.ts";
import { MediaResultItem } from "@modules/resource-search/resource-search-types.ts";
import ResourceSearchCardUtils from "@utils/resource.search.card.utils.ts";
import { getMediaTypeIcon } from "@modules/resource-search/resource-search-helper.ts";
import { useI18n } from "vue-i18n";

export const useMediaCard = () => {
  const { t } = useI18n();

  const populateMediaAddFromLibraryBrowseCardProps = (
    resourceData: MediaResultItem,
  ): ResourceCardProps => {
    const mediaThumbnailSrc = ResourceSearchCardUtils.getSrc(
      resourceData.objectType,
      resourceData.fileUrl,
      resourceData.thumbnailUrl,
    );
    return {
      metadata: getMediaTypeLabel(resourceData.objectType),
      resourceDomain: resourceData.resourceDomain,
      searchType: RESOURCE_SEARCH_TYPE.MEDIA,
      thumbnail: {
        type: mediaThumbnailSrc ? "image" : "icon",
        value: mediaThumbnailSrc ?? getMediaTypeIcon(resourceData.objectType),
      },
      title: resourceData.title,
      uuid: resourceData.uuid,
      ariaLabelConfig: {
        cardComponent: t("search_resource_card_open_in_new_tab_aria_label"),
        viewDetails: t("search_view_details_aria_label", {
          title: resourceData.title,
        }),
      },
    };
  };

  return {
    populateMediaAddFromLibraryBrowseCardProps,
  };
};
